import JsxHelper from '../../../Helpers/JsxHelper';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../../../Enums/TabListTableCellWidthEnum';
import EvaluatorPaymentService from '../../../Services/EvaluatorPaymentService';
import EvaluatorPaymentItem from '../../EvaluatorPaymentItem';

export default class VoidedPaymentAdminItem extends EvaluatorPaymentItem {
  static serviceFunctionForListTable = (item) => EvaluatorPaymentService.GetAssignmentPaymentById(item.IeId);

  static FieldsToShowInDataTable() {
    return [
      { label: 'Pay ID', orderById: 'IeId', data: 'IeId', type: FieldTypesEnum.DataFieldWithDetails },
      { label: 'Evaluator', orderById: 'AsEvname', data: 'AsEvname', minWidth: 100 },
      { label: 'Completed On', orderById: 'AsEvaluatorCompletedDate', data: 'AsEvaluatorCompletedDate', minWidth: 50 },
      { label: 'Fieldwork Office', orderById: 'FieldworkOffice', data: 'FieldworkOffice', minWidth: 50 },
      { label: 'Payment Office', orderById: 'IeLdvname', data: 'IeLdvname', minWidth: 50 },
      { label: 'Void Reason', orderById: 'IeVoidReason', data: 'IeVoidReason', minWidth: 50 },
      { label: 'Export', orderById: 'IeXpid', data: 'IeXpid', minWidth: 50 },
      { label: 'Type', orderById: 'IeType', data: 'IeType', minWidth: 120 },
      { label: 'Status', orderById: 'IeStatus', data: 'IeStatus', minWidth: 50 },
      // CD-5421: sits directly after Status on purpose - it is what explains a Closed payment.
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
      { label: 'Method', orderById: 'IePaymentTypeName', data: 'IePaymentTypeName', minWidth: 50 },
      { label: 'Fee', orderById: 'IeFeeDisplay', data: 'IeFeeDisplay', minWidth: 50 },
      { label: 'Fee Addit.', orderById: 'IeFeeAdjustment', data: 'IeFeeAdjustment', minWidth: 50 },
      { label: 'Expense', orderById: 'IeExpense', data: 'IeExpense', minWidth: 50 },
      { label: 'Tax', orderById: 'IeVat', data: 'IeVat', minWidth: 50 },
      {
        label: ' ',
        orderById: '',
        data: EvaluatorPaymentItem.getActionCellContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 50,
      },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { label: 'Type', name: 'IeType' },
        { label: 'Status', name: 'IeStatus' },
        { label: 'Paid Outside of System', name: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem) },
        { label: 'Assignment', name: EvaluatorPaymentItem.idFunction },
        { label: 'Pay ID', name: 'IeId' },
        { label: 'Location', name: 'CuName' },
        { label: 'Evaluator', name: 'AsEvname' },
        { label: 'Payment Office', name: 'EvaluatorOfficeName' },
        { label: 'Currency', name: 'IeRcyName' },
        { label: 'Payment Method', name: 'IePaymentTypeName' },
        { label: 'Payment Export Date', name: 'IePaymentDate' },
        { label: 'Transaction Date', name: 'IePaidOn' },
        { label: 'Approved On', name: 'IeApprovedOn' },
        { label: 'Created By', name: 'IeCreatedByName' },
        { label: 'Assigned To', name: 'IeAssignedToName' },
        { label: 'Submitted On', name: 'IeSubmittedOn' },
        { label: 'Approved By', name: 'IeApprovedByName' },
        { label: 'Reprinted As', name: 'IeReissuedAs' },
        { label: 'Reprinted From', name: 'IeReissuedFrom' },
        { label: 'Void Reason', name: 'IeVoidReason', width: TabListTableCellWidthEnum.TwoLines },
        { label: 'Comment', name: 'IeComment', width: TabListTableCellWidthEnum.TwoLines },
        { label: 'Fees', name: '-' },
        { label: 'Fee', name: 'IeFeeDisplay' },
        { label: 'Additional Fee', name: 'IeFeeAdjustment' },
        { label: 'Initial Total', name: 'IeTotalDisplay' },
        { label: 'Reimbursement', name: 'IeReimbursement' },
        { label: 'Taxable Total', name: 'IeTaxableTotal' },
        { label: 'Misc', name: 'IeMisc' },
        { label: 'Tax', name: 'IeVat' },
        { label: 'Travel', name: 'IeTravel' },
        { label: 'Paid', name: 'IePaidDisplay' },
        { label: 'Gaming', name: 'IeGaming' },
        { label: 'Current Total Due', name: 'IeDue' },
        { label: 'Export', name: '-' },
        { label: 'Export Payment', name: 'IeExportPaymentId' },
        { label: 'Export', name: 'IeXpid' },
      ],
    },
  ];
}
